export default __webpack_public_path__ + "static/media/cart (2).b6236fce.svg";